import { createContext, useContext, type ReactNode } from 'react';

/** Raw boolean so React context bailout works; provide from DeviceRouter (or a test root). */
export const MobileLayoutContext = createContext(false);
MobileLayoutContext.displayName = 'MobileLayoutContext';

export function MobileLayoutProvider({ isMobileLayout, children }: { isMobileLayout: boolean; children: ReactNode }) {
  return <MobileLayoutContext.Provider value={isMobileLayout}>{children}</MobileLayoutContext.Provider>;
}

export function useMobileLayoutContext(): boolean {
  return useContext(MobileLayoutContext);
}
